module.exports = __webpack_public_path__ + "img/p2_bottom.fa818101.png";